import type { OrderEventActionFormValues } from '@klear/order-event/event-form'
import type { OrderEventActionTypeWire, OrderEventActionWire } from '@klear/order-event/order-event-action.wire'

export const EMPTY_ORDER_EVENT_ACTION_FORM = (type: OrderEventActionTypeWire): OrderEventActionFormValues => ({
  type,
  notes: ''
})

export function orderEventActionFormValuesToWire(form: OrderEventActionFormValues): OrderEventActionWire {
  const wire: OrderEventActionWire = { type: form.type }
  if (form.effectiveDate != null) wire.effectiveDate = form.effectiveDate.toJSON()
  const notes = form.notes?.trim()
  if (notes && notes.length > 0) wire.notes = notes
  if (form.endDate != null) wire.endDate = form.endDate.toJSON()
  if (form.number) wire.number = form.number
  const internalNotes = (form.internalNotes ?? [])
    .map(({ field, note }) => ({ field, note: note.trim() }))
    .filter(({ note }) => note.length > 0)
  if (internalNotes.length > 0) wire.internalNotes = internalNotes
  return wire
}

export function orderEventActionFormValuesToJson(form: OrderEventActionFormValues): string {
  return JSON.stringify(orderEventActionFormValuesToWire(form))
}
